export default "__VITE_ASSET__Bmdfdt6Y__";